// extracted by mini-css-extract-plugin
export var additionalPostLink = "template-post-module--additionalPostLink--1NV93";
export var formWrap = "template-post-module--formWrap--OBwVp";
export var postInfo = "template-post-module--postInfo--3UPxM";
export var wrapContent = "template-post-module--wrapContent--1jwJb";